module.exports = __webpack_public_path__ + "static/media/card2.4a57b9e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/card2.png
// module id = 23
// module chunks = 0